<main>
    <section class="perfil">
        <div class="perfil__side">
            <div class="perfil__side__header">
                <h1>Perfil de {{user?.sNombres}}</h1>
            </div>
            <div class="perfil__side__avatar">
                <div class="image">
                    <img src="assets/img/male-user.png" alt="User">
                </div>
            </div>
        </div>
        <div class="perfil__content">

            <div class="perfil__content__header">
                <div class="title__section">
                    <h2>Datos personales</h2>
                </div>
            </div>

            <div class="perfil__content__content">

                <div class="profile">
                    <div class="profile__item">
                        <label for="">Nombres</label>
                        <input disabled class="" type="text" placeholder="Cargando..." value="{{user?.sNombres || ''}}">
                    </div>
                    <div class="profile__item">
                        <label for="">Primer Apellido</label>
                        <input disabled class="" type="text" placeholder="Cargando..." value="{{user?.sApellidoPaterno || ''}}">
                    </div>
                    <div class="profile__item">
                        <label for="">Segundo Apellido</label>
                        <input disabled type="text" placeholder="Cargando..." value="{{user?.sApellidoMaterno || ''}}">
                    </div>
                    <div class="profile__item">
                        <label for="">Sexo</label>
                        <input disabled type="text" placeholder="Cargando..." value="{{user?.sSexo || ''}}">
                    </div>
                    <div class="profile__item">
                        <label for="">Fecha de Nacimiento</label>
                        <input disabled type="text" placeholder="Cargando..."
                            value=" {{user?.sFechaNacimiento | date:'dd/MM/yyyy' || ''}}">
                    </div>
                </div>
            </div>

            <div class="perfil__content__header">
                <div class="title__section">
                    <h2>Datos de contacto</h2>
                    <ng-container *ngIf="!loading; else loader">
                        <button *ngIf="!edit; else save" class="btn" (click)="editPerfil(true)">
                            <span>Editar</span>
                        </button>
                        <ng-template #save>
                            <button class="btn" (click)="guardarDatos()">
                                <span>Guardar</span>
                            </button>
                            <button class="btn-cancelar btn" (click)="editPerfil(false)">
                                <span>Cancelar</span>
                            </button>
                        </ng-template>
                    </ng-container>

                    <ng-template #loader>
                        <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="perfil__content__content">
                <div class="profile">
                    <div class="profile__item">
                        <label for="">Dirección</label>
                        <input type="text" [(ngModel)]="direccion" placeholder="Cargando..." maxlength="80" value="{{user?.sDireccion || ''}}"
                            [disabled]="!edit">
                    </div>
                    <div class="profile__item">
                        <label for="">Teléfono</label>
                        <input type="text" [(ngModel)]="telefono" maxlength="20" placeholder="Cargando..." [disabled]="!edit"
                            (keypress)="onlyNumber($event)" value="{{user?.sTelefono || ''}}">
                    </div>
                    <div class="profile__item wrap">
                        <label for="">Correo Electrónico</label>
                        <input type="email" maxlength="50" id="correo" [(ngModel)]="email" [disabled]="!edit"
                            placeholder="Cargando..." value="{{user?.sCorreo || ''}}">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="modal" *ngIf="despliegaModal">
        <div class="modal__container">
            <div class="modal__header">
                <h2 class="modal__title">Atención</h2>
            </div>
            <div class="modal__body">
                <div class="modal__form">
                    <p class="alert">{{msjModal}}</p>
                </div>
            </div>
            <div class="modal__footer">
                <button class="btn btn-cancelar" (click)="closeModal()">Cerrar</button>
            </div>
        </div>
    </div>
</main>